export enum PollerStatus {
  NOT_STARTED,
  STARTED,
  FINISHED,
}

export type IPollerStatus = keyof typeof PollerStatus;
